import React  from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import classNames from 'classnames';
import displayError from '../../utilities/displayError';

const DowField = ({ option, input, className, inputClassName }) => {
  const dowFieldClassNames = classNames('custom-control custom-dow', className);
  return (
    <div className={dowFieldClassNames}>
      <input
        {...input}
        type="checkbox"
        id={option.id}
        className={classNames('custom-control-input', inputClassName)}
        defaultChecked={input.value === option.value}
        value={option.value}
      />
      <label
        className="custom-control-label"
        htmlFor={(option.id).replace(/\s/g, '-')}
      >
        <div className="hidden-xs">{option.label}</div>
        <div className="visible-xs">{option.fullLabel}</div>
      </label>
    </div>
  );
};

const RenderDows = ({
  errorMessage = '',
  fields,
  meta = {}
}) => {
  const { error, submitFailed } = meta;
  return (
    <div>
      {
        fields.map((option, index) => {
          return (
            <div className="DowField">
              <Field
                component={DowField}
                name={`dows.${index}`}
                className="margin-lg-bottom"
                errorMessage="Please select an option"
                option={option}
              />
            </div>
          );
        })
      }
      {
        (error && submitFailed) && (
          <p className="error text-danger text-small" style={{ marginTop: '8px' }}>
            {displayError(errorMessage, error)}
          </p>
        )
      }
    </div>
  );
};

DowField.propTypes = {
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })),
  input: PropTypes.object,
  meta: PropTypes.object,
  errorMessage: PropTypes.string,
  option: PropTypes.object
};

RenderDows.propTypes = {
  errorMessage: PropTypes.string,
  fields: PropTypes.array,
  meta: PropTypes.object
};

export default RenderDows;
